import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ScenarioAssessmentRoutingModule } from './scenario-assessment-routing.module';
import { ScenarioAssessmentLinkComponent } from './scenario-assessment-link/scenario-assessment-link.component';
import { ScenarioAssessmentComponent } from './scenario-assessment/scenario-assessment.component';
import { AcademicFormModule } from '../academic-form/academic-form.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCardModule } from '@angular/material/card';
import { MatTableModule } from '@angular/material/table';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatDialogModule } from '@angular/material/dialog';
import { NgxSpinnerModule } from 'ngx-spinner';
import { AssessmentSubmitConfirmComponent } from './assessment-submit-confirm/assessment-submit-confirm.component';


@NgModule({
  declarations: [
    ScenarioAssessmentLinkComponent,
    ScenarioAssessmentComponent,
    AssessmentSubmitConfirmComponent
  ],
  imports: [
    CommonModule,
    ScenarioAssessmentRoutingModule,
    AcademicFormModule,
    ReactiveFormsModule,
    FormsModule,
    MatSelectModule,
    MatFormFieldModule,
    MatCardModule,
    MatTableModule,
    MatDatepickerModule,
    MatInputModule,
    MatProgressSpinnerModule,
    MatDialogModule,
    NgxSpinnerModule.forRoot({ type: 'ball-scale-multiple' }),
  ]
})
export class ScenarioAssessmentModule { }
